import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'app-dk-auth',
  templateUrl: './dk-auth.component.html',
  styleUrls: ['./dk-auth.component.scss']
})
export class DkAuthComponent implements OnChanges {
  @Input() record: any;


  authString: any = null;

  ngOnChanges(changes: SimpleChanges): void {
    const change: any = changes.record?.currentValue;
    if (change) {
      const { createdBy, createdAt, updatedBy, updatedAt } = change?.auth || {}
      this.authString = [
        this.getAuth('created', createdBy, createdAt),
        this.getAuth('updated', updatedBy, updatedAt),
      ].filter(x => !!x).join(', ');
    }
  }

  private getAuth(prefix: any, username: any, stamp: any) {
    if (!username && !stamp) {
      return null;
    }

    const tokens = [];
    tokens.push(prefix);
    if (username) {
      tokens.push(`by ${username}`);
    }
    if (stamp) {
      tokens.push(`at ${this.getTimestampString(stamp)}`)
    }
    return tokens.join(' ');
  }

  private getTimestampString(stamp: any) {
    if (!stamp) {
      return;
    }
    return moment(stamp).format('M/D/YY h:mm a');
  }
}
